export const PERSONAL_SETTINGS_ADMIN_INFO_KEY = "personalSettingsAdminInfo";
